export const FEATURES_FLAGS = [
  'partnerships',
  'ticket-scan',
  'fleet-csv-import',
  'test-drivers',
  'e2e-fixtures',
  'client-recorder',
  'supervisor-qr-signature',
  'supervisor-truck-map',
] as const

export type FeatureFlag = (typeof FEATURES_FLAGS)[number]
export type FeatureFlags = Record<FeatureFlag, boolean>

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = FEATURES_FLAGS.reduce((acc, flag) => {
  acc[flag] = false
  return acc
}, {} as FeatureFlags)
